// third party
import { QueryOptions } from 'react-query';

// local
import { UserSearchResponse } from './users.schema';
import { searchUsers } from './users.api';

export const USER_SEARCH_QUERY_KEY_PREFIX = 'users';

export const getUserSearchQuery = (
  query: string,
): QueryOptions<UserSearchResponse> => {
  const type = query.includes('@') ? 'email' : 'name';
  return {
    queryKey: [USER_SEARCH_QUERY_KEY_PREFIX, { query }],
    queryFn: () => searchUsers(query, type),
  };
};
